import React from 'react';
import PropTypes from 'prop-types';
import getInitials from '../../helpers/utils';

function MentionDropdown({
  mentionPos,
  mentionListRef,
  filteredUsers,
  activeMentionIndex,
  handleMentionClick,
  setActiveMentionIndex,
  bottomSpace,
  ListingStatusComponent,
  className,
  listClassName,
}) {
  return (
    filteredUsers?.length > 0 && (
      <div
        className={className || 'mention-dropdown'}
        style={{
          bottom: bottomSpace,
          right: mentionPos.right,
          zIndex: 1200,
          boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
        }}
        ref={mentionListRef}
        role="listbox"
      >
        <div className={listClassName || 'mention-list'}>
          {filteredUsers?.map((user, idx) => (
            <div
              key={user?.userSub}
              role="option"
              tabIndex="0"
              aria-selected={activeMentionIndex === idx}
              className={`mention-item ${
                activeMentionIndex === idx ? 'active' : ''
              }`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleMentionClick(idx)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === 'Tab') {
                  e.preventDefault();
                  handleMentionClick(idx);
                }
                if (e.key === 'ArrowDown') {
                  e.preventDefault();
                  setActiveMentionIndex((i) =>
                    Math.min(i + 1, filteredUsers.length - 1)
                  );
                }
                if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  setActiveMentionIndex((i) => Math.max(i - 1, 0));
                }
              }}
            >
              <div className="d-flex align-center">
                {user.profilePicture !== '' ? (
                  <img
                    src={user?.profilePicture}
                    alt={`${user?.firstName} ${user?.lastName}`}
                    className="mention-item-avatar"
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                    }}
                  />
                ) : (
                  <span
                    className={`mention-item-avatar ${user?.firstName
                      ?.split('')
                      ?.shift()
                      ?.toLowerCase()}`}
                  >
                    {getInitials(`${`${user?.firstName} ${user?.lastName}`}`)}
                  </span>
                )}

                <div className="mention-item-content">
                  <div className="mention-item-name">
                    {user?.firstName} {user?.lastName}
                  </div>
                  <div className="mention-item-sub">{user?.email}</div>
                </div>
              </div>

              {ListingStatusComponent && (
                <ListingStatusComponent
                  statusLabel={user?.userType}
                  className="d-flex"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    )
  );
}

MentionDropdown.propTypes = {
  mentionPos: PropTypes.shape({
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  mentionListRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  filteredUsers: PropTypes.arrayOf(
    PropTypes.shape({
      userSub: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      email: PropTypes.string,
      profilePicture: PropTypes.string,
      userType: PropTypes.string,
    })
  ).isRequired,
  activeMentionIndex: PropTypes.number.isRequired,
  handleMentionClick: PropTypes.func.isRequired,
  setActiveMentionIndex: PropTypes.func.isRequired,
  bottomSpace: PropTypes.string,
  ListingStatusComponent: PropTypes.elementType,
  className: PropTypes.string,
  listClassName: PropTypes.string,
};

MentionDropdown.defaultProps = {
  bottomSpace: '5.694vw',
  mentionListRef: null,
  ListingStatusComponent: null,
  className: 'mention-dropdown',
  listClassName: 'mention-list',
};

export default MentionDropdown;
